/* ═══════════════════════════════════════════════════════════════════════
   Zustand store — lightweight client-side state (toasts, UI flags)
   Server data lives in React Query, not here.
   ═══════════════════════════════════════════════════════════════════════ */

import { create } from "zustand";

// ── Toast ────────────────────────────────────────────────────────────

export interface Toast {
  id: number;
  message: string;
  type: "info" | "success" | "error";
}

interface AppState {
  toasts: Toast[];
  addToast: (message: string, type?: Toast["type"]) => void;
  removeToast: (id: number) => void;
}

let toastId = 0;

export const useAppStore = create<AppState>((set) => ({
  toasts: [],

  addToast: (message, type = "info") => {
    const id = ++toastId;
    set((s) => ({ toasts: [...s.toasts, { id, message, type }] }));
    // auto-remove after 4 seconds
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
    }, 4000);
  },

  removeToast: (id) => {
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
  },
}));
